<template>
  <div class="work-info-component">
    <div class="work-title">{{ work.title }}</div>
    <div class="work-info">
      <div class="work-date">{{ work.createdTime|formatTime('yyyy-MM-dd') }}</div>
    </div>
    <template v-if="work.partContent">
      <div v-if="work.partContent.length"
           class="work-content-title">作品内容</div>
      <ym-content class="work-content"
                  :content="work.partContent"
      />
      <ym-img v-for="(item,index) in work.imageList"
              :key="`image${index}`"
              class="work-content-image"
              :src="item"
      />
      <template v-if="!hiddenVideo">
        <div v-if="work.videoList.length"
             class="work-content-title">作品视频</div>
        <ym-video v-for="(item,index) in work.videoList"
                  :key="`video${index}`"
                  class="work-content-video"
                  :src="item"
        />
      </template>
      <template v-if="audioList.length">
        <div class="work-content-title">作品录音</div>
        <div class="work-content-audio-list">
          <div v-for="(item, index) in audioList"
               :key="`audio${index}`"
               @click="handlePlayAudio(index)"
               class="work-content-audio-item"
          >
            <ym-img class="work-content-audio-item-icon"
                    :src="require('@/assets/img/course/icon_audio.png')"
            />
            <div :id="`audio-gif-${index}`"
                 class="work-content-audio-item-gif"></div>
            <span v-if="item.duration"
                  class="work-content-audio-item-text">
              {{ item.duration }}秒
            </span>
          </div>
        </div>
      </template>
    </template>
    <ym-content v-else
                class="work-content"
                :content="work.content"
    />
  </div>
</template>

<script>
  import lottie from 'lottie-web';
  import YmVideo from '@/components/YmVideo';
  import Content from '@/components/RichText';
  import audioGif from '@/assets/img/course/audio.json';

  export default {
    name: 'WorkInfoComponent',
    components: {
      'ym-content': Content,
      YmVideo,
    },
    props: {
      work: {
        type: Object,
        default() {
          return {};
        },
      },
      hiddenVideo: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        audioList: [],
      };
    },
    methods: {
      initAudio(index) {
        const icon = document.getElementById(`audio-gif-${index}`);
        const gif = lottie.loadAnimation({
          container: icon, // 包含动画的dom元素
          renderer: 'svg', // 渲染出来的是什么格式
          loop: true, // 循环播放
          autoplay: false, // 自动播放
          animationData: audioGif, // 动画json的路径
        });
        this.audioList[index].gif = gif;
        this.audioList[index].audioPlayer = new Audio(this.audioList[index].src);
        this.audioList[index].audioPlayer.addEventListener('canplay', () => {
          this.$set(this.audioList[index], 'duration', parseInt(this.audioList[index].audioPlayer.duration, 10));
        });
        this.audioList[index].audioPlayer.addEventListener('ended', () => {
          this.audioList[index].gif.stop();
        });
      },
      handlePlayAudio(currIndex) {
        this.audioList.forEach((item, itemIndex) => {
          if (currIndex === itemIndex && item.audioPlayer.paused) {
            item.audioPlayer.play();
            item.gif.play();
            return;
          }
          item.gif.stop();
          item.audioPlayer.pause();
        });
      },
    },
    created() {
      let list = [];
      if (this.hiddenVideo && !this.work.audioList.length) {
        list = this.work.videoList;
      } else {
        list = this.work.audioList;
      }
      this.audioList = list.map(item => ({ src: item }));
      this.$nextTick(() => {
        for (let i = 0; i < this.audioList.length; i++) {
          this.initAudio(i);
        }
      });
    },
    beforeDestroy() {
      this.handlePlayAudio(9999);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .work-info-component {
    margin-bottom: @size-small;
    padding: @size-extra-medium @size-base;
    background: @color-white;
  }

  .work-title {
    margin-bottom: @size-medium;
    font-weight: @font-weight-primary;
    font-size: @font-size-extra-large;
    color: @color-text-base;
    line-height: 1.4;
  }

  .work-info {
    margin-bottom: @size-small;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-base;
    color: @color-text-lighter;
  }

  .work-count-info {
    display: flex;
    align-items: center;
    span {
      margin-left: @size-small;
    }
  }

  .work-content {
    word-break: break-all;
    line-height: 1.4;
    &-title {
      color: #1a1a1a;
      font-size: 36px;
      font-weight: bold;
      margin: 80px 0 30px;
    }
    &-image {
      width: 100%;
    }
    &-video {
      display: block;
      width: 100%;
    }
    &-audio {
      &-list {
        display: flex;
        flex-direction: column;
      }
      &-item {
        align-self: baseline;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        border-radius: 20px;
        padding: 0 40px;
        background-color: #02cccc;
        margin-bottom: 30px;
        &-icon {
          width: 28px;
          height: 40px;
        }
        &-gif {
          width: 164px;
          height: 80px;
        }
        &-text {
          color: #fff;
          font-size: 32px;
        }
      }
    }
  }
</style>
